module.exports = __webpack_public_path__ + "img/gestaltra_logo.7615d008.png";